import React from 'react';

export interface MiniTableColumn {
  key: string;
  label: string;
  width?: string;
  align?: 'left' | 'right' | 'center';
  render?: (value: unknown, row: Record<string, unknown>) => React.ReactNode;
}

interface MiniTableProps {
  columns: MiniTableColumn[];
  rows: Record<string, unknown>[];
  maxRows?: number;
}

export default function MiniTable({ columns, rows, maxRows = 5 }: MiniTableProps) {
  const displayRows = rows.slice(0, maxRows);
  return (
    <div className="w-full overflow-x-auto scrollbar-thin">
      <table className="w-full text-xs min-w-max">
        <thead>
          <tr className="border-b border-border">
            {columns.map((col) => (
              <th
                key={`th-${col.key}`}
                className={`pb-2 pt-1 font-medium text-muted-foreground whitespace-nowrap pr-3 ${
                  col.align === 'right' ? 'text-right' : col.align === 'center' ? 'text-center' : 'text-left'
                }`}
                style={col.width ? { width: col.width } : undefined}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {displayRows.map((row, i) => (
            <tr
              key={`row-${String(row.id ?? i)}`}
              className="border-b border-border/50 hover:bg-muted/30 transition-colors"
            >
              {columns.map((col) => (
                <td
                  key={`td-${String(row.id ?? i)}-${col.key}`}
                  className={`py-2 pr-3 font-tabular ${
                    col.align === 'right' ? 'text-right' : col.align === 'center' ? 'text-center' : 'text-left'
                  }`}
                >
                  {col.render
                    ? col.render(row[col.key], row)
                    : <span className="text-foreground">{String(row[col.key] ?? '—')}</span>}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}